/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('#contact-form-Floors').on('input',function(e){
 $('.form__radio input[name="contact[Room Construction Floors]"]').prop('checked', false);
});


$('#contact-form-Walls').on('input',function(e){
 $('.form__radio input[name="contact[Room Construction Walls]"]').prop('checked', false);
});


$('.form__radio input[name="contact[Room Construction Floors]"]').on('click change', function(e) {
 $('#contact-form-Floors').val('').removeClass('form__field--text is-filled');
});

$('.form__radio input[name="contact[Room Construction Walls]"]').on('click change', function(e) {
 $('#contact-form-Walls').val('').removeClass('form__field--text is-filled');
});


$('.collection_global_desc p').each(function() {
    var $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
        $this.remove();
});

/**
 * Instant-search dropdown: hide the price and the "Save $X" sale badge on
 * products tagged 'no-price'.
 *
 * Boost's instant-search payload doesn't carry product tags, so the Liquid
 * {% unless %} guards used on the grid/search templates can't work here.
 * Instead we resolve tags per product: from the card's data-product blob when
 * present, otherwise from /products/<handle>.js (which DOES return tags),
 * cached per handle. These selectors are dropdown-only, so the collection
 * grid, /search page and recommendations (all guarded in Liquid) are never
 * touched.
 */
(function () {
  // Dropdown-only price nodes (both class families Boost may use) plus the
  // "Save $X" sale badge overlaying the suggestion thumbnail. All dropdown-only.
  var PRICE_SEL = '.boost-sd__instant-search-results .boost-sd__product-price, ' +
                  '.boost-sd__suggestion-queries-item-amount, ' +
                  '.boost-sd__suggestion-queries-item-badge--sale';

  var cache = {}; // handle -> boolean (resolved) | Promise (in flight)

  function hide(el) { el.style.display = 'none'; }

  function handleOf(link) {
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Resolve the product handle for a price node without guessing card classes:
  // either the price sits inside the product's own <a>, or we walk up to the
  // first ancestor whose product links all agree on ONE handle. If an ancestor
  // spans multiple products we bail — never hide the wrong product's price.
  function resolveHandle(priceEl) {
    var anchor = priceEl.closest('a[href*="/products/"]');
    if (anchor) return handleOf(anchor);

    var scope = priceEl.parentElement;
    while (scope && scope !== document.body) {
      var links = scope.querySelectorAll('a[href*="/products/"]');
      if (links.length) {
        var handle = null;
        for (var i = 0; i < links.length; i++) {
          var h = handleOf(links[i]);
          if (!h) continue;
          if (handle === null) handle = h;
          else if (handle !== h) return null; // mixed products — too high, bail
        }
        return handle;
      }
      scope = scope.parentElement;
    }
    return null;
  }

  function tagsFor(priceEl) {
    var holder = priceEl.closest('[data-product]');
    if (!holder) return null;
    try {
      var data = JSON.parse(holder.getAttribute('data-product'));
      // Trust only a non-empty tags array; otherwise fall through to the fetch.
      return data && Array.isArray(data.tags) && data.tags.length ? data.tags : null;
    } catch (e) { return null; }
  }

  function noPriceFor(handle) {
    if (!(handle in cache)) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = !!(p && (p.tags || []).indexOf('no-price') !== -1);
          cache[handle] = v; // collapse to boolean; 404 caches false (no refetch loop)
          return v;
        })
        .catch(function () { delete cache[handle]; return false; }); // network error -> retry later
    }
    var v = cache[handle];
    return typeof v === 'boolean' ? Promise.resolve(v) : v;
  }

  function process(priceEl) {
    if (priceEl.__ataNoPriceDone) return;

    var tags = tagsFor(priceEl);
    if (tags) {
      priceEl.__ataNoPriceDone = true;
      if (tags.indexOf('no-price') !== -1) hide(priceEl);
      return;
    }

    var handle = resolveHandle(priceEl);
    if (!handle) return; // not resolvable yet — retry on a later mutation
    priceEl.__ataNoPriceDone = true;

    noPriceFor(handle).then(function (noPrice) {
      if (noPrice) hide(priceEl);
    });
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(PRICE_SEL)) process(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(PRICE_SEL), process);
    }
  }

  // Boost renders/re-renders the dropdown asynchronously on every keystroke;
  // scan only added subtrees (same shape as the other observers in this file).
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document.documentElement);
})();